import { Injectable } from '@angular/core';
import { NavigationExtras, Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  public previousUrl = '';

  // private directionsService: google.maps.DirectionsService;

  constructor(
    private _router: Router,
    private _location: Location,
  ) {
    _router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise(),
      )
      .subscribe((events: RoutesRecognized[]) => {
        this.previousUrl = events[0].urlAfterRedirects;
      });
  }

  private _routeToUrl(url: string, navigationData?: NavigationExtras) {
    this._router.navigate([url], navigationData).then();
  }

  routeBack() {
    this._location.back();
  }

  routeToSettings() {
    const url = this._router.serializeUrl(
      this._router.createUrlTree(['/', 'settings']),
    );
    return this._routeToUrl(url);
  }

  //#region Authentication routes

  routeToLogin(returnUrl?: string) {
    this._routeToUrl('/authentication/login', {
      queryParams: { returnUrl: returnUrl },
    });
  }

  routeToRegister() {
    this._routeToUrl('/authentication/register');
  }

  routeToForgotPass() {
    this._routeToUrl('/authentication/forgot-password');
  }

  routeToResetPassword() {
    this._routeToUrl('/authentication/reset-password');
  }

  //#endregion Authentication routes
}
